import {combineReducers} from "redux";
import {navReducer, pathReducer} from "./router";
import {receiver} from "./testreceive";
import {conversations} from "./conversations";
import {login} from "./login";

const reducers = {
    location: pathReducer,
    nav: navReducer,
    testReceive: receiver,
    session: conversations,
    auth: login
};

export const rootReducer = combineReducers(reducers);


// WEBPACK FOOTER //
// ./src/reducers/root.js